import { TreeViewNode } from 'models';

/**
 * Counts leaf (page) nodes in a tree, ignoring folder nodes. A node is a
 * page only if it carries a `source` (set by transformSitemapToTreeView for
 * every real page) — checking for absent `children` alone would also count
 * an all-external-URL directory (which has no `source` and no `children`,
 * see transformSitemapToTreeView) as a page.
 */
export const countTreeLeaves = (items: TreeViewNode[]): number =>
	items.reduce((count, node) => {
		if (node.children && node.children.length > 0) {
			return count + countTreeLeaves(node.children);
		}
		return node.source ? count + 1 : count;
	}, 0);
